<template>
  <tr>
    <td class="shrink">
      <ItemId :item-id="secret.id" />
    </td>
    <td>
      <router-link
        :to="{ name: 'secret-details', params: { name: secret.name.split('/') } }"
        title="Secret details"
        :target="selectable ? '_blank' : null"
      >
        {{ secret.name }}
      </router-link>
    </td>
    <td v-if="selectable">
      <button
        class="button is-primary"
        type="button"
        v-on:click="() => $emit('select')"
      >
        Select
      </button>
    </td>
  </tr>
</template>

<script lang="ts">
import { type PropType, defineComponent } from 'vue'

import ItemId from '@/components/ItemId.vue'
import { corporaMixin, truncateMixin } from '@/mixins'
import type { SecretLight } from '@/types/secret'

export default defineComponent({
  mixins: [corporaMixin, truncateMixin],
  components: {
    ItemId,
  },
  emits: {
    select: () => true,
  },
  props: {
    secret: {
      type: Object as PropType<SecretLight>,
      required: true,
    },
    /**
     * Whether a button should be shown to allow selecting this secret. This will trigger a `select` event.
     */
    selectable: {
      type: Boolean,
      default: false,
    },
  },
})
</script>
